import {CONSTANTS} from '@/constants'
import miniToastr from 'mini-toastr'


export const functions_tasks = {
    data: function () {
        return {
            tasks:[],
            task:null,
            tasktypes:[],
        }
    },
    methods: {

        createTask: function (onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('task/create')).then(function (response) {
                response = this.httpSuccess(response);
                if (response.result === 'success')
                {
                    this.showMessageTaskCreated({title:'Задача '+response.payload.id+' создана'});
                    this.$refs.tasksTable.refresh();
                    this.$router.push({ path: '/task/'+response.payload.id})
                    miniToastr["success"](response.message, 'Задача создавна', CONSTANTS.TOAST_SUCCESS_LIFETIME);
                }
                else {
                    console.log('response.error', response.error);
                }
            }, this.httpError)
        },


        saveTask: function (cmd, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('task/'+this.task.id+'/save'), {cmd:cmd, task:this.task}).then(function (response) {
                response = this.httpSuccess(response);
                this.task = response.payload;
                miniToastr["success"](response.message, 'Задача сохранена', CONSTANTS.TOAST_SUCCESS_LIFETIME);
                this.executeFunction(onSuccess, param);
                this.setLatestTask(this.task.id);
            }, this.httpError);
        },

        startTask: function (payload, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('task/start'), {payload:payload}).then(function (response) {
                response = this.httpSuccess(response);
                this.task = response.payload;
                miniToastr["success"](response.message, 'Задача создана', CONSTANTS.TOAST_SUCCESS_LIFETIME);
                this.executeFunction(onSuccess, param);
                this.setLatestTask(this.task.id);
            }, this.httpError);
        },

        assignTask: function (assignee, comment, onSuccess=null, param=null) {
            // this.httpPrepare(response);
            // this.$http.post(this.apiurl('task/assign'), {assignee:assignee, comment:comment}).then(function (response) {
            //     response = this.httpSuccess(response);
            //     this.task = response.payload;
            //     this.executeFunction(onSuccess, param);
            // }, this.httpError);
        },

      /*
       *      Задача
       */

        loadTask: function (task_id, onSuccess=null, param=null) {
            console.log('loadTask '+task_id   )
            if (!this.isTaskLoaded() && task_id) {
                this.httpPrepare();
                this.$http.get(this.apiurl('task/' + task_id)).then(function (response) {
                    response = this.httpSuccess(response);
                    this.task = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetTask: function () {
            this.task = null;
            return this;
        },

        isTaskLoaded: function () {
            return (this.task !== null) && this.task && this.task.id;
        },


        /*
        *   Виды задач
        */

        // TODO  сделать preload TaskTypes
        loadTaskTypes: function (onSuccess=null, param=null) {
            if (!this.isTaskTypesLoaded()) {
                this.httpPrepare();
                this.$http.get(this.apiurl('task/types')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.tasktypes = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetTaskTypes: function () {
            this.tasktypes = [];
            return this;
        },

        isTaskTypesLoaded: function () {
            return this.is(this.tasktypes)  && this.tasktypes.length;
        },

        getTaskTypeTitleById: function (id) {
            if (!this.is(id)) {
                return 'не указано';
            }

            for (let i=0; i<this.tasktypes.length; i++) {
                if (this.tasktypes[i].id === id) {
                    return this.tasktypes[i];
                }
            }

            return null;
        },

        latestTaskClass: function (task) {
            return this.isLatest('App\\Models\\Task', task.id) ? 'latest' : '';
        },
        setLatestTask: function (id) {
            this.setLatest('App\\Models\\Task', id);
        },

    },
    computed: {

    }
};
